import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { useClientAuth } from './auth';
import './styles-proto.css';
import './styles-extra.css';
import './responsive.css'; // 手机/窄屏响应式覆盖（须在全局样式之后引入）
import './styles-accessibility.css';

const qc = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});
useClientAuth.subscribe((next, previous) => {
  if (next.token !== previous.token || next.user?.id !== previous.user?.id) qc.clear();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
